/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'line-dash-dash': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 2',
    data: '<path pid="0" stroke="currentColor" stroke-width="2" d="M0 1h9.5M14.5 1H24"/>',
    lastMod: '1793794573354.2883'
  }
})
